module.exports = __webpack_public_path__ + "static/media/growth.336eb3b9.jpg";